import { Auth } from "aws-amplify";
import React, { Component } from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Authenticated from "./config/Authenticated";
import awsConfigure from "./config/AwsConfig";
import { withAppContext } from "./store/contextStore";
import VersionChecker from "./components/VersionChecker";
import WelcomeVideoModal from "./components/WelcomeVideoModal";

class App extends Component {
  async componentDidMount() {
    this.loadFacebookSDK();
    try {
      await Auth.currentAuthenticatedUser();
      this.userHasAuthenticated(true);
    } catch (e) {
      if (e !== "not authenticated") {
        console.log(e, "alert console");
      }
    }
    this.setState({ isAuthenticating: false });
  }

  loadFacebookSDK() {
    console.log("scoail JSD calling function from ");
    window.fbAsyncInit = function() {
      window.FB.init({
        appId:            awsConfigure.social.FB,
        autoLogAppEvents: true,
        cookie:           true,
        xfbml:            true,
        version:          "v11.0",
      });
    };
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, "script", "facebook-jssdk"));
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  };

  render() {
    return (
      <Router>
        <VersionChecker context={this.props.context} />
        <WelcomeVideoModal context={this.props.context} />
        <Switch>
          <Route path="/" component={Authenticated} />
        </Switch>
      </Router>
    );
  }
}

export default withAppContext(App);
